import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysPaiementController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysPaiementController.php
* @route '/api/company/{company}/elys/paiement'
*/
const ElysPaiementController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysPaiementController.url(args, options),
    method: 'post',
})

ElysPaiementController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/elys/paiement',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysPaiementController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysPaiementController.php
* @route '/api/company/{company}/elys/paiement'
*/
ElysPaiementController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return ElysPaiementController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysPaiementController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysPaiementController.php
* @route '/api/company/{company}/elys/paiement'
*/
ElysPaiementController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysPaiementController.url(args, options),
    method: 'post',
})

export default ElysPaiementController